// extracted by extract-css-chunks-webpack-plugin
module.exports = {"message-form":"trLbZ_VqlB87t6yFCxBE","row":"KQphivyIfSHh2MiGk7s1","full":"DxqeJiv35_U7JSZICHUe","half":"WopwlxXCCEQ8LGsWhB4t"};